import React from 'react';
import { useNavigate, useParams } from 'react-router';

import { BackButton, Loading, NOTIFICATION_TYPE, Notification } from 'components';
import { BuyerForm } from 'features/buyers/components/form/BuyerForm';
import { useGetBuyer } from 'features/buyers/hooks/useGetBuyer';

export function EditBuyer() {
  const { id } = useParams();
  const { data: buyer, isFetching, isLoading, error } = useGetBuyer(id);

  const navigate = useNavigate();

  const onSuccess = () => {
    Notification(NOTIFICATION_TYPE.SUCCESS, 'Buyer was updated successfully');
    navigate(-1);
  };

  const onError = (error) => {
    Notification(NOTIFICATION_TYPE.DANGER, error.message);
  };

  if (isFetching || isLoading) {
    return <Loading />;
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  return (
    <div>
      <div className="mb-4">
        <BackButton />
      </div>

      <div className="row mb-4">
        <h1>Edit Buyer</h1>
      </div>

      <BuyerForm action="edit" initialValues={buyer} onSuccess={onSuccess} onError={onError} />
    </div>
  );
}
